import { createMittBffClient } from '@/app/bffClient';
import { getGroupedCustomerContracts } from 'bff-api/mitt-malarenergi';
import { getSelectedCustomer } from '@/app/slices/userSlice';
import { GroupedContracts } from '@/features/contracts/contractSlice';
import { userIsNonCustomer } from '@/helpers/customerUtils';
import { State } from '@/types/State';
import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

export const groupedContractsWithExpiredQueryKey = (
  customerId: number | undefined,
) => ['groupedContracts', customerId, 'withExpired'] as const;

const useGroupedContractsWithExpired = () => {
  const selectedCustomer = useSelector((state: State) =>
    getSelectedCustomer(state),
  );

  const { data: groupedContractsWithExpired = null } =
    useQuery<GroupedContracts>({
      queryKey: groupedContractsWithExpiredQueryKey(
        selectedCustomer?.customerId,
      ),
      queryFn: async () => {
        const client = await createMittBffClient();
        const result = await getGroupedCustomerContracts({
          client,
          path: { customerId: selectedCustomer!.customerId },
          query: { includeExpiredContractsLast3Years: true },
        });
        if (result.response?.status === 404) {
          return null;
        }
        if (result.error) {
          throw result.error;
        }
        return (result.data?.data?.[0] ?? {}) as GroupedContracts;
      },
      enabled: !!selectedCustomer?.customerId && !userIsNonCustomer(selectedCustomer),
      staleTime: 5 * 60 * 1000,
    });

  return { groupedContractsWithExpired };
};

export default useGroupedContractsWithExpired;
